export enum PageType {
    PlantManagerCreate = '1',
    PlantManagerEdit = '2',
    ProjectManagerCreate = '3',
    ProjectManagerEdit = '4',
    PlantManagerEditWithLatestSchema = '5',
    ActivityPackAdd = '6',
    ActivityPackEdit = '7',
    PlantManagerCopy = '8',
    ProjectMangerCopy = '9',
    PlantManagerMove = '10',
    WorkpackClone = '11',
    workpackCopy = '12',
    workpackMove = '13',
    AddActivityTaggedItem = '14',
    EditActivityTaggedItem = '15',
    AddLeakItem = '16',
    EditLeakItem = '17',
    AddExceptionItem = '18',
    EditExceptionItem = '19',
    LeakEditWithLatestSchema = '20',
    ProjectManagerEditWithLatestSchema = '21',
    ActivityPackEditWithLatestSchema = '22',
    WorkPackAllocateFromView = '23',
    PlantManagerAllocatefromView = '24',
    ExceptionEditWithLatestSchema = '25',
    ActivityTaggedItemEditWithLatestSchema = '26',
    TrainingUnitCreate = '27',
    TrainingUnitEdit = '28',
}
export enum AreaType {
    PlantManager = '1',
    WorkpackManager = '2',
}
export enum ActionType {
    PlantManager = '1',
    Allocation = '2',
    ActivityRecords = '3',
    Documents = '4',
}
export enum ActivityPackStatus {
    Complete = '200',
    InProgress = '100',
    NoStarted = '10',
}
